import React from 'react'
import { useInView } from 'react-intersection-observer';

export default function AnimationIn({ animationName, duration=2, type="ease", children }) {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });
    return (
        <div
            ref={ref}
            className={animationName}
            style={{
                animation: inView ? `${animationName} ${duration}s ${type} forwards` : ""
            }}
        >
            {children}
        </div>
    );
}
